/** @format */

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark, faAdd } from '@fortawesome/free-solid-svg-icons';

export default function BrokerServiceBox({
  service,
  index,
  iconType,
  isEditMode,
  onClick
}) {
  const icon = iconType === 'add' ? faAdd : faCircleXmark;
  return (
    <>
      <div className='text4 my-services-item' key={index}>
        <p>{service} </p>
        {isEditMode && (
          <FontAwesomeIcon
            icon={icon}
            size='sm'
            onClick={() => onClick(index)}
          />
        )}
      </div>
    </>
  );
}
